import { RegistrationStep } from '@/types/enums/forms/registration/registrationWizard';

export const RegistrationMachine = {
    transitions: {
        [RegistrationStep.PersonalDetails]: {
            next: RegistrationStep.ProfessionalDetails,
        },
        [RegistrationStep.ProfessionalDetails]: {
            next: RegistrationStep.ContactDetails,
            prev: RegistrationStep.PersonalDetails,
        },
        [RegistrationStep.ContactDetails]: {
            next: RegistrationStep.Identity,
            prev: RegistrationStep.ProfessionalDetails,
        },
        [RegistrationStep.Identity]: {
            next: RegistrationStep.Address,
            prev: RegistrationStep.ContactDetails,
        },
        [RegistrationStep.Address]: {
            prev: RegistrationStep.Identity,
        },
    },
};
